<template>
  <v-container grid-list-lg class="relatorio-produtividade pa-0 ma-0" fluid>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
        <v-card
          flat
          :style="
            !$vuetify.breakpoint.smAndDown
              ? 'padding-left: 30px; padding-right: 30px;'
              : 'padding-top: 15px; padding-bottom: 10px;'
          "
        >
          <v-card-title class="pt-0 pb-0">
            <v-layout
              row
              wrap
              :align-center="$vuetify.breakpoint.smAndUp"
              :align-content-center="$vuetify.breakpoint.smAndDown"
            >
              <v-flex class="flex-menu-container my-2" xs12 sm11 md12 lg4>
                <v-menu
                  v-model="filtro.status.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroStatusString() == 'Filtro'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                    >{{ filtroComputed.filtroStatusString() }}</v-btn
                  >
                  <v-card
                    :max-width="!$vuetify.breakpoint.smAndDown ? '200px' : ''"
                  >
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex
                        xs12
                        v-for="status in filtro.status.opcoes"
                        :key="status.id"
                      >
                        <v-btn
                          @click="
                            buscarApolicesByStatus(status.id),
                              (filtro.status.selecionado = status.titulo),
                              (filtro.status.selecionadoId = status.id)
                          "
                          :color="
                            filtroComputed.statusSelecionadoDescricaoString() ==
                            status
                              ? 'primary'
                              : 'themeGrey'
                          "
                          round
                          block
                          :outline="
                            filtroComputed.statusSelecionadoDescricaoString() !=
                              filtro
                          "
                          >{{ status.titulo }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
        <v-card
          flat
          :style="
            !$vuetify.breakpoint.smAndDown
              ? 'padding-left: 30px; padding-right: 30px;'
              : 'padding-top: 15px; padding-bottom: 10px;'
          "
        >
          <v-card-title class="pt-0 pb-0">
            <v-layout
              row
              wrap
              :align-center="$vuetify.breakpoint.smAndUp"
              :align-content-center="$vuetify.breakpoint.smAndDown"
            >
              <v-spacer></v-spacer>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-container class="pa-0">
      <v-flex
        md12
        style="display: flex; justify-content: flex-end; margin-top: 15px"
        class="pa-0"
      >
        <v-btn color="secondary" @click="dialogSelecaoPeriodo = true" round>
          GERAR RELATÓRIO
        </v-btn>
      </v-flex>
    </v-container>
    <div style="padding:20px 50px">
      <template>
        <div>
          <v-data-table
            :headers="headers"
            :items="relatorioInfoDadosModel"
            hide-actions
            :rows-per-page-items="[10]"
            item-key="item"
            class="elevation-1 table-grid"
          >
            <template v-slot:items="props">
              <td class="linhas-tabela">
                {{ formartarData(props.item.dataSolicitacao) }}
              </td>
              <td class="linhas-tabela">{{ props.item.nomeUsuario }}</td>
              <td class="linhas-tabela">{{ getTitulo(props.item.tipoRelatorio) }}</td>
              <td class="linhas-tabela">
                {{ props.item.statusRelatorio.titulo }}
              </td>
              <td class="linhas-tabela">{{ props.item.periodo }}</td>
              <td class="linhas-tabela">{{ props.item.codigoApolice }}</td>
              <td class="linhas-tabela">
                <v-btn
                  v-if="isFalha(props.item.statusRelatorio.id)"
                  color="error"
                  flat
                  style="border: 0"
                  @click="verErro(props.item.motivoFalha)"
                >
                  VER ERRO
                </v-btn>
                <v-btn
                  v-else
                  color="secondary"
                  flat
                  style="border: 0"
                  :disabled="isDisabledDownload(props.item.statusRelatorio.id)"
                  @click="baixarRelatorio(props.item.idRelatorio)"
                >
                  BAIXAR
                </v-btn>
              </td>
            </template>
            <template slot="no-data">
              <p style="margin: 15px 0;font-size: 16px;  text-align:center">
                Não há itens para exibir.
              </p>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="paginacao.page"
              :length="paginacao.totalPages"
              circle
            ></v-pagination>
          </div>
        </div>
      </template>
      <v-snackbar
        :timeout="3000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel"
      >
        {{ snackbar.mensagem }}
        <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
      <template> </template>
    </div>
    <v-dialog v-model="dialogSelecaoPeriodo" width="300">
      <v-card class="dialog-filtro-consulta ">
        <v-card-title
          class="headline lighten-2 pa-3"
          primary-title
          style="color: white;background-color: #00456e; font-size: 22px!important"
        >
          Gerar Relatório
        </v-card-title>
        <v-divider></v-divider>
        <v-form v-model="validaFormRelatorio">

          <v-container class="pa-3" v-show="exibirOpcoesRelatorios">
            <v-select
              label="Tipo de relatório"
              v-model="idListaSelecionada"
              :items="listaOpcoesRelatorios"

              item-value="id"
              item-text="titulo"
            ></v-select>
          </v-container>
          <v-container v-show="exibirRelatorioIndicador" class="pa-3">
            <v-menu
              v-model="dataInicioDialog"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="320px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dataInicioComputada"
                  label="Data Início"
                  prepend-icon="event"
                  readonly
                  v-on="on"

                ></v-text-field>
              </template>
              <v-date-picker
                v-model="grupoDatas.dataInicio"
                @input="dataInicioDialog = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
              v-model="dataFimDialog"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="200px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="pt-0"
                  v-model="dataFimComputada"
                  label="Data Fim"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="grupoDatas.dataFim"
                @input="dataFimDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-container>
          <v-container v-show="exibirRelatorioVeiculo" class="pa-3">
            <v-text-field
              v-model="grupoDatas.codigoApolice"
              label="Código da Cotacão"
              :rule="numericRule"
            >
            </v-text-field>
          </v-container>
          <v-card-actions>
            <v-layout row wrap class="px-2 ">
              <v-flex md12>
                <v-btn
                  class="mb-2"
                  :disabled="habilitarBotaoProximo"
                  color="primary"
                  block
                  @click="proximoRelatorios"
                  v-show="exibirOpcoesRelatorios"
                >
                  próximo
                </v-btn>
              </v-flex>
              <v-flex md12>
                <v-btn
                  class="mb-2"
                  @click="submitRelatorio()"
                  :disabled="isDisabledGerar"
                  color="primary"
                  block
                  v-show="!exibirOpcoesRelatorios"
                >
                  GERAR
                </v-btn>
              </v-flex>
              <v-flex md12>
                <v-btn
                  v-show="!exibirOpcoesRelatorios"
                  color="primary"
                  flat
                  outline
                  block
                  @click="voltarRelatorios"
                >
                  VOLTAR
                </v-btn>
              </v-flex>
              <v-flex md12>
                <v-btn
                  v-show="exibirOpcoesRelatorios"
                  color="primary"
                  flat
                  outline
                  block
                  @click="fecharDialogSelecao"
                >
                  CANCELAR
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogErro" width="420">
      <v-card class="dialog-filtro-consulta">
        <v-card-title
          class="headline lighten-2 pa-3"
          primary-title
          style="color: white;background-color: #00456e; font-size: 22px!important"
        >
          Falha na geração do relatório
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="font-size: 16px">
          {{ mensagemErro }}
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap class="px-2">
            <v-flex md12>
              <v-btn
                class="mb-2"
                color="primary"
                block
                @click="dialogErro = false"
              >
                FECHAR
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "GridRelatorioProdutividade",
  data() {
    return {
      validaFormRelatorio: true,
      exibirOpcoesRelatorios: true,
      exibirRelatorioIndicador: false,
      exibirRelatorioVeiculo: false,
      idListaSelecionada: null,
      listaOpcoesRelatorios: [
        {
          id: 1,
          titulo: "Relatório de Indicadores"
        },
        {
          id: 2,
          titulo: "Relatório de Veículos"
        }
      ],
      grupoDatas: {
        codigoApolice: null,
        campoDataInicio: null,
        campoDataFim: null,
        periodoData: null,
        tipoRelatorio: null,
        filtroRelatorio: 1
      },
      dataInicioDialog: false,
      dataFimDialog: false,
      dialogSelecaoPeriodo: false,
      dialogErro: false,
      mensagemErro: "",
      relatorioInfoDadosModel: [],
      dataInicioFiltrada: this.formartarData(new Date().toISOString()),
      dataFimFiltrada: this.formartarData(new Date().toISOString()),
      dialog: false,
      loading: false,
      paginacao: {
        page: parseInt(
          sessionStorage.getItem("pageGridRelatorioProdutividade")),
        size: 10,
        totalPages: 0
      },
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ""
      },
      filtro: {
        status: {
          opened: false,
          opcoes: [
            { id: 0, titulo: "TODOS" },
            { id: 1, titulo: "CONCLUÍDO" },
            { id: 2, titulo: "EM PROCESSAMENTO" },
            { id: 3, titulo: "FALHA" }
          ],
          selecionado: null
        }
      },
      headers: [
        {
          text: "Data Solicitação",
          value: "dataSolicitacao",
          align: "center",
          sortable: false
        },
        { text: "Usuário", value: "usuario", align: "center", sortable: false },
        { text: "Tipo", value: "tipoRelatorio", align: "center", sortable: false },
        { text: "Status", value: "status", align: "center", sortable: false },
        {
          text: "Período",
          value: "periodo",
          sortable: false,
          align: "center",
          sortable: false
        },
        {
          text: "Cód. Cotacão",
          value: "codigoApolice",
          sortable: false,
          align: "center",
          sortable: false
        },
        { text: "Ações", sortable: false, align: "center" }
      ]
    };
  },
  mounted() {
    if (sessionStorage.getItem("pageGridRelatorioProdutividade") == null) {
      this.paginacao.page = 1;
    }
    this.listarConsultaRelatorios();
  },
  computed: {
    dataInicioComputada() {
      return this.formartarData(this.grupoDatas.dataInicio);
    },
    dataFimComputada() {
      return this.formartarData(this.grupoDatas.dataFim);
    },

    requiredRule() {
        return value => !!value || 'Campo precisa ser preenchido'
    },
    numericRule() {
        return value => /^\d+$/.test(value) || 'Este campo só aceita valores numéricos.'
    },
    customFormatComputed: function() {
      return CustomFormat;
    },

    isDisabledGerar() {
      if(this.idListaSelecionada == 1) {
        if (
          this.grupoDatas.dataInicio == null ||
          this.grupoDatas.dataFim == null ||
          this.grupoDatas.dataInicio == undefined ||
          this.grupoDatas.dataFim == undefined
        ) {
          return true;
        }
      } else if(this.idListaSelecionada == 2) {
        if(this.grupoDatas.codigoApolice == null || !/^\d+$/.test(this.grupoDatas.codigoApolice)) {
          return true
        }
      }
      else {
        return false;
      }
    },

    filtroComputed: function() {
      const self = this;
      return {
        filtroStatusString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado;
          } else {
            return "Filtro";
          }
        },
        statusSelecionadoDescricaoString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado;
          } else {
            return "";
          }
        }
      };
    },
    habilitarBotaoProximo() {
      return this.idListaSelecionada == null;
    }
  },
  watch: {
    "paginacao.page"(val) {
      this.listarConsultaRelatorios();
      sessionStorage.setItem("pageGridRelatorioProdutividade", val);
    },
  },
  methods: {
    proximoRelatorios() {
      if ( this.idListaSelecionada === 1 ) {
        this.setarTipoRelatorio(1);
        this.exibirRelatorioIndicador = true;
      } else if( this.idListaSelecionada === 2 ) {
        this.setarTipoRelatorio(2);
        this.exibirRelatorioVeiculo = true;
      }
      this.exibirOpcoesRelatorios = false;
    },
    voltarRelatorios() {
      this.exibirOpcoesRelatorios = true;
      this.grupoDatas.dataInicio = null;
      this.grupoDatas.dataFim = null;
      this.grupoDatas.codigoApolice = null;
      this.grupoDatas.tipoRelatorio = null;
      this.grupoDatas.filtroRelatorio = 1;
      this.exibirRelatorioVeiculo = false;
      this.exibirRelatorioIndicador = false;
    },
    formartarData(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    fecharDialogSelecao() {
      this.dialogSelecaoPeriodo = false;
      this.grupoDatas.dataInicio = null;
      this.grupoDatas.dataFim = null;
      this.grupoDatas.codigoApolice = null;
      this.grupoDatas.filtroRelatorio = 1;
      this.idListaSelecionada = null;
      this.exibirOpcoesRelatorios = true;
      this.exibirRelatorioVeiculo = false;
      this.exibirRelatorioIndicador = false;
    },
    formatData(date) {
      return new Date(date).toLocaleDateString("pt-BR");
    },

    setarTipoRelatorio(id) {
      this.grupoDatas.tipoRelatorio = id;
    },

     getTitulo(tipoRelatorio) {
        return tipoRelatorio && tipoRelatorio.titulo ? tipoRelatorio.titulo : ' ';
    },

    isFalha(id) {
      return id === 3;
    },

    verErro(motivoFalha) {
      this.mensagemErro =
        motivoFalha ||
        "Não foi possível gerar o relatório. Tente novamente em alguns minutos; se persistir, acione o suporte.";
      this.dialogErro = true;
    },

    isDisabledDownload(id) {
      if (id === 1) {
        return false;
      } else {
        return true;
      }
    },

    submitRelatorio() {
      axios
        .post(
          `${process.env.URL_RELATORIOSMS}/v1/gerarRelatorio`,
          this.grupoDatas,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(res => {
          this.fecharDialogSelecao();
          this.listarConsultaRelatorios();
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    listarConsultaRelatorios() {
      this.loaderPagina = true;
      axios
        .get(
          `${
            process.env.URL_RELATORIOSMS
          }/v1/listarConsultaRelatorios?page=${this.paginacao.page -
            1}&size=${this.paginacao.size}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(res => {
          this.relatorioInfoDadosModel = res.data.content;
          this.relatorioInfoDadosModel.map(item => {
            if (item.periodo) {
              let dataInicio = item.periodo.substring(0, 10);
              let dataFim = item.periodo.substring(11);
              const dataInicioFormatada = this.formartarData(dataInicio);
              const dataFimFormatada = this.formartarData(dataFim);
              item.periodo = dataInicioFormatada + "-" + dataFimFormatada;
            }
          });

          this.paginacao.totalPages = res.data.totalPages;
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
          this.loaderPagina = false;
        });
    },

    async baixarRelatorio(idRelatorio) {
      try {
        const response = await axios.get(
          `${process.env.URL_RELATORIOSMS}/v1/downloadRelatorio/${idRelatorio}`,
          {
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Relatório-Indicadores.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = error.response.data.message;
      }
    }
  }
};
</script>
<style>
.relatorio-produtividade .theme--light.v-table thead tr:first-child {
  background-color: #00456e;
}
.relatorio-produtividade .v-datatable thead th.column {
  color: #fff !important;
}
.relatorio-produtividade
  .theme--light.v-datatable
  thead
  th.column.sortable.active
  .v-icon {
  color: #fff;
}
.dialog-filtro-consulta {
  border-radius: 10px;
}
.relatorio-produtividade .v-dialog {
  border-radius: 10px;
}
.flex-special-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-menu-container {
  display: flex;
  align-items: center;
}
.linhas-tabela {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tela-relatorio-produtividade/GridRelatorioProdutividade.vue